import script from "./LLM.vue?vue&type=script&setup=true&lang=ts"
export * from "./LLM.vue?vue&type=script&setup=true&lang=ts"

import "./LLM.vue?vue&type=style&index=0&id=0afa7d10&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0afa7d10"]])

export default __exports__